"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGlobalLoading = exports.GlobalLoadingProvider = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var LoadingGlobalContainer_1 = __importDefault(require("../containers/LoadingGlobalContainer"));
var GlobalLoadingContext = (0, react_1.createContext)({});
var GlobalLoadingProvider = function (_a) {
    var children = _a.children;
    var _b = (0, react_1.useState)(false), isLoading = _b[0], setIsLoading = _b[1];
    var _c = (0, react_1.useState)(''), description = _c[0], setDescription = _c[1];
    var updateLoading = (0, react_1.useCallback)(function (isLoading) {
        setIsLoading(isLoading);
    }, []);
    var updateLoadingDescription = (0, react_1.useCallback)(function (message) {
        setDescription(message);
    }, []);
    var resetLoading = (0, react_1.useCallback)(function () {
        setIsLoading(false);
        setDescription('');
    }, []);
    var showLoading = (0, react_1.useCallback)(function (message) {
        setIsLoading(true);
        if (!!message) {
            setDescription(message);
        }
    }, []);
    var hiddenLoading = (0, react_1.useCallback)(function () {
        setIsLoading(false);
        setDescription('');
    }, []);
    return ((0, jsx_runtime_1.jsxs)(GlobalLoadingContext.Provider, __assign({ value: {
            isLoading: isLoading,
            updateLoading: updateLoading,
            updateLoadingDescription: updateLoadingDescription,
            resetLoading: resetLoading,
            showLoading: showLoading,
            hiddenLoading: hiddenLoading,
        } }, { children: [isLoading ? (0, jsx_runtime_1.jsx)(LoadingGlobalContainer_1.default, { description: description }) : null, children] })));
};
exports.GlobalLoadingProvider = GlobalLoadingProvider;
var useGlobalLoading = function () {
    var loadingGlobal = (0, react_1.useContext)(GlobalLoadingContext);
    if (!loadingGlobal) {
        throw new Error('useLoadingGlobal must be used within a LoadingGlobalContext');
    }
    return loadingGlobal;
};
exports.useGlobalLoading = useGlobalLoading;
